import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import { IEntitySource, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_BatchScopeCRRow, WB_BatchScopeMRRow,
    WB_BatchScopeRow, WB_BatchScopeSRRow,
    WB_CompanyRow, WB_MasterDataSetRow,
    WB_SalesOrgRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbBatchScope } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_BatchScope, esWB_BatchScopeCR, esWB_BatchScopeMR, esWB_BatchScopeSR,
    esWB_Company, esWB_MasterData_Set,
    esWB_SalesOrg
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";
import {BehaviorSubject} from "rxjs";
import {BatchScopeBOValidations} from "./BatchScopeBO.Validations";

export class BatchScopeBO
    implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_BatchScope: WB_BatchScopeRow;


    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Batch Scope'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_BatchScope = undefined;

        this.IBatchScope_init();
    }



    get WB_BatchScope():WB_BatchScopeRow{
        return  this.drWB_BatchScope;
    }
    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating Batch Scope");
        let rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Batch Scope.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);

                return self;
            }
            try {
                // Create record using dbContext
                let batchScopeRow: WB_BatchScopeRow = <WB_BatchScopeRow>await self.dbContext.createRecordWithKey(esWB_BatchScope)
                batchScopeRow.setDefaults()
                self.drWB_BatchScope = batchScopeRow;
                self.dbContext.add(esWB_BatchScope, batchScopeRow)
                self.Identity.setAll(self.WB_BatchScope.cif.WB_BATCHSCOPE_ID, self.WB_BatchScope.cif.BATCHSCOPE_ID, self.WB_BatchScope.cif.BATCHSCOPE_NAME);
                self.Identity.listenToRecordUpdates(self.WB_BatchScope, 'WB_BATCHSCOPE_ID', 'BATCHSCOPE_ID', 'BATCHSCOPE_NAME')
                self.Identity.enableRecordWriteBack(self.WB_BatchScope, "BATCHSCOPE_ID", 'BATCHSCOPE_NAME')

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        let rv = self._OnLoadComplete = (async () => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Batch Scope already loaded.");
                self._OnLoadComplete = undefined;
                return self;
            }

            self.LoadOptions = options || {};

            try {
                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext({});
                }

                if (_.isEmpty(self.dbContext)) {
                    self.LoadProgressProvider.exception("Unable to determine dbContext for Batch Scope.");
                    return self;
                }


                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = BatchScopeBO.createRecordResolver({dbContext: self.dbContext})
                    recordResolverLoadPromise = BatchScopeBO.setupRecordResolver(recordResolver, [anId])
                }


                await recordResolverLoadPromise
                let aBatchScopeRow: any = recordResolver.get(esWB_BatchScope, anId)

                if (_.isEmpty(aBatchScopeRow)) {
                    throw "Batch Scope not found";
                }

                self.drWB_BatchScope = aBatchScopeRow;
                self.Identity.setAll(self.WB_BatchScope.cif.WB_BATCHSCOPE_ID, self.WB_BatchScope.cif.BATCHSCOPE_ID, self.WB_BatchScope.cif.BATCHSCOPE_NAME);
                self.Identity.listenToRecordUpdates(self.WB_BatchScope, 'WB_BATCHSCOPE_ID', 'BATCHSCOPE_ID', 'BATCHSCOPE_NAME')
                self.Identity.enableRecordWriteBack(self.WB_BatchScope, "BATCHSCOPE_ID", 'BATCHSCOPE_NAME')
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                return self;
            } catch
                (err) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                throw err
            }

        })();

        return rv;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_BatchScope.cif.MDSET_NAME + "(" + self.WB_BatchScope.cif.MDSET_ID + ")");

        self.ValidateOptions = options || {};
        try {
            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for to Validate Batch Scope.";
                self.ValidateProgressProvider.exception(sError);
                return self;
            }
            await BatchScopeBOValidations.Validate(self)

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self.ValidateMessageProvider.addMessage({code: 'Exception', type: MessageType.Error, description: JSON.stringify(err), title: 'Validation Exception'})
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        self._bIsSaved = false
        const wbBatchScope = <IwbBatchScope>self.drWB_BatchScope;
        self.SaveProgressProvider.start("Saving " + wbBatchScope.BATCHSCOPE_NAME + "(" + wbBatchScope.BATCHSCOPE_ID + ")");
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                let sError = "Unable to determine dbContext to Save Batch Scope.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            await self.Validate(options)
            if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                self.SaveProgressProvider.finish();
                return self
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_BatchScope, self.drWB_BatchScope, {})

            let tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_BatchScopeMR, self.drWB_BatchScope.WB_BatchScopeMRRows))
            tasks.push(saveFunction(esWB_BatchScopeCR, self.drWB_BatchScope.WB_BatchScopeCRRows))
            tasks.push(saveFunction(esWB_BatchScopeSR, self.drWB_BatchScope.WB_BatchScopeSRRows))

            await Promise.all(tasks)


            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        const batchScope = <IwbBatchScope>self.drWB_BatchScope;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + batchScope.BATCHSCOPE_NAME + "(" + batchScope.BATCHSCOPE_ID + ")");

        try {
            // 1. Validate if we can delete the Batch Scope
            await BatchScopeBOValidations.ValidateDelete(self)
            if(self.DeleteMessageProvider.countMessages(MessageType.Error) > 0){
                return self
            }

            // 2. If Valid, mark all the records for deletion.
            self.drWB_BatchScope.markDeleted()

            _.forEach(self.drWB_BatchScope.WB_BatchScopeMRRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
            })

            _.forEach(self.drWB_BatchScope.WB_BatchScopeCRRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
            })

            _.forEach(self.drWB_BatchScope.WB_BatchScopeSRRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
            })


            if (bSaveNow) {
                await self.SaveUsing(false)

                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return (self);
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return self;
            }

        } catch (err) {
            self.DeleteProgressProvider.exception(err)
            return self
        }
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        let tasks: Promise<any>[] = [];
        self.LoadProgressProvider.setProgressMessage('BatchScopeBO.PostLoad', 'Processing Loaded Data');
        tasks.push(self.IBatchScope_onLoadComplete())
        await Promise.all(tasks)
        return
    }


    //</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.WB_BatchScope, opts)
    }



    //</editor-fold>

    //<editor-fold desc = "Add Remove operations">

    //<editor-fold desc = "IBatchScope operations">

    private _onMasterDataSetChanged: BehaviorSubject<BatchScopeBO>
    private _onCompaniesChanged: BehaviorSubject<BatchScopeBO>
    private _onSalesOrgsChanged: BehaviorSubject<BatchScopeBO>

    private _allMasterDataSets: WB_MasterDataSetRow[]
    private _allCompanies: WB_CompanyRow[]
    private _allSalesOrgs: WB_SalesOrgRow[]

    private mdsEntitySource: IEntitySource
    private soEntitySource: IEntitySource
    private coEntitySource: IEntitySource

    private IBatchScope_init() {
        //--
        this._onMasterDataSetChanged = new BehaviorSubject<BatchScopeBO>(undefined)
        this._onCompaniesChanged = new BehaviorSubject<BatchScopeBO>(undefined)
        this._onSalesOrgsChanged = new BehaviorSubject<BatchScopeBO>(undefined)
        this._allMasterDataSets = []
        this._allCompanies = []
        this._allSalesOrgs = []

    }

    private async IBatchScope_onLoadComplete(): Promise<void> {
        const self = this
        this._allMasterDataSets = await self.dbContext.findAll(esWB_MasterData_Set, {where: {DELETED_IND: {neq: '1'}}})
        this._allSalesOrgs = await self.dbContext.findAll(esWB_SalesOrg, {where: {DELETED_IND: {neq: '1'}}})
        this._allCompanies = await self.dbContext.findAll(esWB_Company, {where: {DELETED_IND: {neq: '1'}}})

        this.mdsEntitySource = {
            get Entities(){ return self._allMasterDataSets },
            get Selected(){ return self.MasterDataSets },
            keyFields: {
                id: 'WB_MDSET_ID',
                id_ui: 'MDSET_ID',
                name: 'MDSET_NAME'
            },
            onChange: this._onMasterDataSetChanged,
            addSelection(id: number): Promise<void> {  return  self.addMasterDataSet(id).then() },
            removeSelection(id: number): Promise<void> { return self.removeMasterDataSet(id).then() }
        }

        this.soEntitySource = {
            get Entities(){ return self._allSalesOrgs },
            get Selected(){ return self.SalesOrgs },
            keyFields: {
                id: 'WB_SALESORG_ID',
                id_ui: 'SALESORG_ID',
                name: 'SALESORG_NAME'
            },
            onChange: this._onSalesOrgsChanged,
            addSelection(id: number): Promise<void> {  return self.addSalesOrg(id).then() },
            removeSelection(id: number): Promise<void> { return self.removeSalesOrg(id).then() }
        }

        this.coEntitySource = {
            get Entities(){ return self._allCompanies },
            get Selected(){ return self.Companies },
            keyFields: {
                id: 'WB_COMPANY_ID',
                id_ui: 'COMPANY_ID',
                name: 'COMPANY_NAME'
            },
            onChange: this._onCompaniesChanged,
            addSelection(id: number): Promise<void> {  return self.addCompany(id).then() },
            removeSelection(id: number): Promise<void> { return self.removeCompany(id)}
        }


    }

    get MasterDataSetEntitySource(): IEntitySource { return this.mdsEntitySource }

    get SalesOrgEntitySource(): IEntitySource { return this.soEntitySource }

    get CompanyEntitySource(): IEntitySource { return this.coEntitySource }

    get MasterDataSets(): WB_MasterDataSetRow[] {
        // @ts-expect-error "filter has bad typings"
        return _.map(_.filter(this?.WB_BatchScope?.WB_BatchScopeMRRows || [], (a) => a.isActive && a.WB_MasterDataSetRow), (b) => b.WB_MasterDataSetRow)
    }
    get OnMasterDataSetChanged(): BehaviorSubject<BatchScopeBO> { return this._onMasterDataSetChanged }

    get Companies(): WB_CompanyRow[] {
        // @ts-expect-error "filter has bad typings"
        return _.map(_.filter(this?.WB_BatchScope?.WB_BatchScopeCRRows || [], (a) => a.isActive && a.WB_CompanyRow), (b) => b.WB_CompanyRow)
    }
    get OnCompaniesChanged(): BehaviorSubject<BatchScopeBO> { return this._onCompaniesChanged }

    get SalesOrgs(): WB_SalesOrgRow[] {
        // @ts-expect-error "filter has bad typings"
        return _.map(_.filter(this?.WB_BatchScope?.WB_BatchScopeSRRows || [], (a) => a.isActive && a.WB_SalesOrgRow), (b) => b.WB_SalesOrgRow)
    }
    get OnSalesOrgsChanged(): BehaviorSubject<BatchScopeBO> { return this._onSalesOrgsChanged }


    //-- Master Data Set API
    async addMasterDataSet(wbMDSetId: number): Promise<WB_BatchScopeMRRow> {
        const self = this
        const aMDSetRow = <WB_MasterDataSetRow> await self.dbContext.find(esWB_MasterData_Set, wbMDSetId)
        if(_.isEmpty(aMDSetRow))
            return undefined
        const aNewRow = <WB_BatchScopeMRRow> await self.dbContext.createRecordWithKey(esWB_BatchScopeMR)
        aNewRow.setDefaults()
        aNewRow.cif.WB_BATCHSCOPE_ID = self.drWB_BatchScope.cif.WB_BATCHSCOPE_ID
        aNewRow.WB_BatchScopeRow = self.drWB_BatchScope
        aNewRow.cif.WB_MDSET_ID = aMDSetRow.cif.WB_MDSET_ID
        aNewRow.WB_MasterDataSetRow = aMDSetRow
        self.dbContext.add(esWB_BatchScopeMR, aNewRow)
        self.OnMasterDataSetChanged.next(self)
        return aNewRow
    }

    async removeMasterDataSet(aWbMDSetId: number): Promise<void> {
        const self = this

        for (const wbBatchScopeMRRow of self.drWB_BatchScope.WB_BatchScopeMRRows) {
            if (wbBatchScopeMRRow.isActive && wbBatchScopeMRRow.cif.WB_MDSET_ID == aWbMDSetId) {
                wbBatchScopeMRRow.markDeleted()
                break;
            }
        }

        self.OnMasterDataSetChanged.next(self)
    }

    //-- Company API
    async addCompany(wbCompanyId: number): Promise<WB_BatchScopeCRRow> {
        const self = this
        const aCompanyRow: WB_CompanyRow = <WB_CompanyRow> await self.dbContext.find(esWB_Company, wbCompanyId)
        if(_.isEmpty(aCompanyRow))
            return undefined
        const aNewRow = <WB_BatchScopeCRRow> await self.dbContext.createRecordWithKey(esWB_BatchScopeCR)
        aNewRow.setDefaults()
        aNewRow.cif.WB_BATCHSCOPE_ID = self.drWB_BatchScope.cif.WB_BATCHSCOPE_ID
        aNewRow.WB_BatchScopeRow = self.drWB_BatchScope
        aNewRow.cif.WB_COMPANY_ID = aCompanyRow.cif.WB_COMPANY_ID
        aNewRow.WB_CompanyRow = aCompanyRow
        self.dbContext.add(esWB_BatchScopeCR, aNewRow)
        self.OnCompaniesChanged.next(self)
        return aNewRow
    }

    async removeCompany(aWbCompanyId: number): Promise<void> {
        const self = this

        for (const wbBatchScopeCRRow of self.drWB_BatchScope.WB_BatchScopeCRRows) {
            if (wbBatchScopeCRRow.isActive && wbBatchScopeCRRow.cif.WB_COMPANY_ID == aWbCompanyId) {
                wbBatchScopeCRRow.markDeleted()
                break;
            }
        }

        self.OnCompaniesChanged.next(self)
    }



    //-- SalesOrg API
    async addSalesOrg(wbSalesOrgId: number): Promise<WB_BatchScopeSRRow> {
        const self = this
        const aSalesOrgRow = <WB_SalesOrgRow> await self.dbContext.find(esWB_SalesOrg, wbSalesOrgId)
        if(_.isEmpty(aSalesOrgRow))
            return undefined
        const aNewRow = <WB_BatchScopeSRRow> await self.dbContext.createRecordWithKey(esWB_BatchScopeSR)
        aNewRow.setDefaults()
        aNewRow.cif.WB_BATCHSCOPE_ID = self.drWB_BatchScope.cif.WB_BATCHSCOPE_ID
        aNewRow.WB_BatchScopeRow = self.drWB_BatchScope
        aNewRow.cif.WB_SALESORG_ID = aSalesOrgRow.cif.WB_SALESORG_ID
        aNewRow.WB_SalesOrgRow = aSalesOrgRow
        self.dbContext.add(esWB_BatchScopeSR, aNewRow)
        self.OnSalesOrgsChanged.next(self)
        return aNewRow
    }

    async removeSalesOrg(aWbSalesOrgId: number): Promise<void> {
        const self = this

        for (const wbBatchScopeSRRow of self.drWB_BatchScope.WB_BatchScopeSRRows) {
            if (wbBatchScopeSRRow.isActive && wbBatchScopeSRRow.cif.WB_SALESORG_ID == aWbSalesOrgId) {
                wbBatchScopeSRRow.markDeleted()
                break;
            }
        }

        self.OnSalesOrgsChanged.next(self)
    }

    //</editor-fold>


    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const scope_options: CreateOptions = {
            standardConditions: {
                [esWB_BatchScope]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_BatchScopeMR]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_BatchScopeCR]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_BatchScopeSR]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {},
            dctExcludeHasManyNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, scope_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_BatchScope, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

};

PAEnvironment.registerBusinessObjectClass(BatchScopeBO, "BatchScopeBO", "Batch Scope")
